import moment from "moment";
import { FC, useEffect, useState } from "react";
import { CollectionUtil, LocalStorage, RequestUtil } from "src/framework/commons";
import { FullWidthButton } from "src/framework/components/buttons";
import { STATUS_CODE } from "src/framework/providers/api";
import { notifierStore, userInfo$ } from "src/framework/store";
import { ITermoAceite, ResponseTermoAceiteFinanceiras } from "src/providers/cadastros/TermosAceiteProvider/types";
import { financeirasProvider } from "src/providers/financeiro/Financeiras";
import pagamentoProvider from "src/providers/pagamentos/PagamentosProvider";
import { CacheType, getFinanceiras, getParcelasDisponiveis } from "src/store/global.store";
import { Clientes, ErrorValidate, FinanceiraType, FinanciamentoParcela, FinanciamentoSimulacao, PedidoType, Simulacao, TTIPO_TERMO_ACEITE } from "src/types";
import { TermosDeAceite } from "../../termos/TermosDeAceite";
import { FinanceiraButton } from "./FinanceiraButton";
import { FinanciamentosGrid } from "./FinanciamentosGrid";
import { SimulacaoForm } from "./SimulacaoForm";

import { BehaviorSubject } from "rxjs";
import { useObservable } from "src/framework/store/storeUtil";
import { ModalSCR } from "../../termos/TermosDeAceite/ModalSCR";

import "./styles.scss";
import { FINANCEIRA_PARCEIRO_ID, FINANCEIRA_SANTANDER_ID } from "../constants";


export const openModalSCR$ = new BehaviorSubject<boolean>(false);
interface ErrorState {
    banco: ErrorValidate
    documentos: ErrorValidate
}

const DATA_SIMULACAO: Simulacao = {
    data_nascimento_fundacao: "",
    financeiras: [],
    parcelas: 0,
    valor: 0,
    valor_mensal_renda_faturamento: 0

}

const INITIAL_ERROR_STATE: ErrorState = {
    documentos: {
        hasError: false,
        hintText: ""
    },
    banco: {
        hasError: false,
        hintText: ""
    },
}

interface onConfirmarData {
    simulacao: FinanciamentoSimulacao | null;
    financeira: FinanceiraType | null;
    parcela: FinanciamentoParcela | null;
}

export interface FinanceirasProperties {
    pedido?: PedidoType | null;
    dadosCiente?: Clientes | null;
    onChange: (simulacao: FinanciamentoSimulacao | null, financeira: FinanceiraType | null, parcela: FinanciamentoParcela | null) => void
    solo: boolean;
    disabledConfirmar: boolean;
    onClose?: () => void;
}

const Financeiras: FC<FinanceirasProperties> = ({
    pedido,
    dadosCiente,
    solo,
    onClose,
    disabledConfirmar = false,
    onChange
}) => {
    /** States e propriedades **/
    const openModalSCR = useObservable(openModalSCR$);
    const [financeirasListState, setFinanceirasListState] = useState<CacheType<FinanceiraType[]> | null>(null);
    const [financeirasHabilitadas, setFinanceirasHabilitadas] = useState<number[]>([])
    const [simulacaoState, setSimulacaoState] = useState<Simulacao>(DATA_SIMULACAO)
    const [simlulacaoResultState, setSimulacaoResultState] = useState<FinanciamentoSimulacao[]>([])
    const [disabled, setDisabled] = useState<boolean>(false);
    const [errorState, setErrorState] = useState<ErrorState>(INITIAL_ERROR_STATE);


    const [listaTermosAceite, setListaTermosAceite] = useState<ResponseTermoAceiteFinanceiras[]>([])
    const [financeiraTermosAceiteIds, setFinanceiraTermosAceiteIds] = useState<number[]>([])
    const [listaTermosAceiteState, setListaTermosAceiteState] = useState<ITermoAceite[]>([])

    const [openTermosAceite, setOpenTermoAceite] = useState<boolean>(false);

    const [confirmData, setConfirmData] = useState<onConfirmarData>({
        financeira: null,
        parcela: null,
        simulacao: null,
    });

    /** Métodos **/

    const isPessoaJuridica = (): boolean => {
        if (dadosCiente?.tipo_pessoa === "juridica") {
            return true;
        }
        return false;
    }

    const simular = async (termos: ITermoAceite[]): Promise<void> => {
        if (pedido?.codigo_venda) {
            setSimulacaoResultState([]);
            const _simulacaoState: Simulacao = CollectionUtil.merge({}, simulacaoState)
            _simulacaoState.data_nascimento_fundacao = moment(String(_simulacaoState.data_nascimento_fundacao), "YYYY-MM-DD 00:00:00").format("YYYY-MM-DD")
            for (const idx in _simulacaoState.financeiras) {
                const _termos = termos.filter(_t => _simulacaoState.financeiras[idx].financeira_id === _t.financeira_id)
                if (_termos) {
                    _simulacaoState.financeiras[idx].termos = _termos.map((_t) => {
                        if (openTermosAceite === false && !_t.codigo_integrador) {
                            return { ..._t, }
                        }

                        return {..._t,}
                    }).filter(Boolean)
                    _simulacaoState.financeiras[idx].termos_simulacao = openTermosAceite ? _termos.map((_t) => {
                        return {
                            aceito: !!_t.aceito ? _t.aceito : false,
                            codigo_integrador: _t.codigo_integrador,
                            texto: _t.texto
                        }
                    }) : []
                }
            }

            const user = userInfo$.getValue();

            const sessao: any = {
                os: navigator.platform,
                userAgent: navigator.userAgent,
                language: navigator.language,
                user: user?.user || "",
                geolocation: null
            }

            navigator.geolocation.getCurrentPosition((geo) => {
                if (geo) {
                    sessao.geolocation = geo
                }
            })


            _simulacaoState["sessao"] = sessao;

            const response = await pagamentoProvider.simularFinanciamento(pedido.codigo_venda, _simulacaoState)

            if (response.statusCode === STATUS_CODE.OK) {
                const _financeiraAceitas: any = ((termos.map(t => t.financeira_id).filter(Boolean)).filter((t, i, self) => self.indexOf(t) === i)) || []
                setFinanceiraTermosAceiteIds([...financeiraTermosAceiteIds, ..._financeiraAceitas].filter((t, i, self) => self.indexOf(t) === i))
                setSimulacaoResultState(response.data)
            }
        }
    }

    const validaSimulacao = (): boolean => {
        const messages: string[] = [];

        if (simulacaoState.financeiras?.length === 0) {
            messages.push("Selecione ao menos uma financeira.");
        }

        if (Number(simulacaoState.valor_mensal_renda_faturamento) <= 0) {
            messages.push("O campo Renda mensal deve ser maior que 0 (Zero).");
        }

        if (Number(simulacaoState.parcelas) <= 0) {
            messages.push("Escolha ao menos uma parcela.");
        }

        if (!simulacaoState.data_nascimento_fundacao) {
            if (isPessoaJuridica()) {
                messages.push("O campo data de fundação é obrigatório.");
            } else {
                messages.push("O campo data de nascimento é obrigatório.");
            }
        }

        if (messages.length > 0) {
            notifierStore.setNotifier({
                title: "Aviso!!!",
                content: messages,
                onClose: () => {
                    notifierStore.setOpen(false);
                },
                timeOut: 2500,
            });
            notifierStore.setOpen(true);
            return false;
        }

        return messages.length === 0
    }


    const validacao = (): boolean => {
        const errorMessages: string[] = []
        const errors = { ...errorState }


        if (errorMessages.length > 0) {
            setErrorState({ ...errors })
            notifierStore.setNotifier({
                title: "Aviso",
                content: errorMessages,
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false)
                }
            })
            notifierStore.setOpen(true)

            return false
        }

        return true;
    }

    const validaExibicaoTermos = (): ResponseTermoAceiteFinanceiras[] => {
        let listaValida: ResponseTermoAceiteFinanceiras[] = [];
        for (const _financeira of listaTermosAceite) {
            if (simulacaoState.financeiras?.map(f => {
                return f.financeira_id
            })?.includes(_financeira.financeira_id)
                && !financeiraTermosAceiteIds.includes(_financeira.financeira_id)) {
                if (_financeira.termos && _financeira.termos.length > 0) {
                    listaValida.push(_financeira)
                }
            }
        }
        return listaValida;
    }

    const listaTermos = (): ITermoAceite[] => {
        const _termos: ITermoAceite[] = []
        for (const t of validaExibicaoTermos()) {
            if (t.termos.length) {
                _termos.push(...t.termos)
            }
        }
        return _termos
    }

    /** Effects **/
    useEffect(() => {
        RequestUtil.loader({
            asyncRequest: [],
            syncRequest: [
                getFinanceiras(),
                getParcelasDisponiveis(),
            ],
            syncResponses: (_response) => {
                const financeiras = LocalStorage.get("solar.financeiras", true)
                const filteredFinanceiras = (financeiras?.data || []).filter((financeira: any) => {
                    const hideFinanceirasIdList = [FINANCEIRA_SANTANDER_ID, FINANCEIRA_PARCEIRO_ID]
                    return !hideFinanceirasIdList.includes(financeira.id)
                })
                setFinanceirasListState({ ...financeiras, data: filteredFinanceiras.sort(CollectionUtil.singleSort('id')) });
            }
        })
        return () => {
            setSimulacaoState(Object.assign({}, DATA_SIMULACAO))
        }
    }, [])

    useEffect(() => {
        (async () => {
            RequestUtil.loader({
                asyncRequest: [],
                syncRequest: [
                    getFinanceiras(),
                    getParcelasDisponiveis(),
                ],
                syncResponses: (_response) => {
                    const financeiras = LocalStorage.get("solar.financeiras", true)
                    const filteredFinanceiras = (financeiras?.data || []).filter((financeira: any) => {
                        const hideFinanceirasIdList = [FINANCEIRA_SANTANDER_ID, FINANCEIRA_PARCEIRO_ID]
                        return !hideFinanceirasIdList.includes(financeira.id)
                    })
                    setFinanceirasListState({ ...financeiras, data: filteredFinanceiras.sort(CollectionUtil.singleSort('id')) });    
                }
            });
            if (pedido?.valor_pagamento) {
                const _simulacaoState = { ...simulacaoState }
                _simulacaoState.valor = pedido.valor_pagamento
                if (pedido.codigo_venda) {
                    const responseHabilitadas = await financeirasProvider.getFinanceirasValidas(pedido.codigo_venda);
                    if (responseHabilitadas.length) {
                        if (pedido?.cpf_cnpj) {
                            const responseTermosFinanceiras = await financeirasProvider.getTermosFinanceiras(pedido.codigo_venda, responseHabilitadas)
                            if (responseTermosFinanceiras.statusCode === STATUS_CODE.OK) {
                                setListaTermosAceite([...responseTermosFinanceiras.data]);
                            }
                        }
                        setFinanceirasHabilitadas(responseHabilitadas.filter((financeiraId: any) => {
                            const hideFinanceirasIdList = [FINANCEIRA_SANTANDER_ID, FINANCEIRA_PARCEIRO_ID]
                            return !hideFinanceirasIdList.includes(financeiraId)
                        }))
                    }
                }
                setSimulacaoState({ ..._simulacaoState })
            }
        })();
    }, [pedido?.valor_pagamento]);

    return <div className="Financeiras">
        <div className="row">
            <div className="X12 list-instituicoes-title">
                Selecione a instituição:
            </div>
            {financeirasListState?.data?.map((f, index) => {
                return <div className="X12 S6 M4 L2" key={`financieras-${index}`}><FinanceiraButton
                    text={`${f?.nome}`}
                    color={"default"}
                    disabled={!financeirasHabilitadas.includes(f.id)}
                    // isChecked={financeirasHabilitadas.includes(f.id)}
                    onClick={(isChecked) => {
                        const _data = simulacaoState;
                        _data.financeiras = _data.financeiras?.map(_f => {
                            return {
                                financeira_id: _f.financeira_id
                            }
                        })?.filter((_f) => _f.financeira_id !== f?.id)

                        if (isChecked && f?.id) {
                            _data.financeiras?.push({
                                financeira_id: f.id
                            })
                        }

                        setSimulacaoState({ ..._data })
                    }}
                /></div>
            })}
        </div>
        <SimulacaoForm
            data={simulacaoState}
            isPessoaJuridica={isPessoaJuridica()}
            onChange={(newValue) => {
                setSimulacaoState({ ...newValue })
            }}
        />
        <div className="row">
            <div className="X12">
                <FullWidthButton
                    text="Clique aqui para simular"
                    color="secondary" 
                    disabled={simulacaoState.financeiras.length === 0}
                    variant="outlined"
                    onClick={async () => {
                        if (!validaSimulacao()) {
                            return;
                        }
                        if (validaExibicaoTermos() && listaTermos().length > 0) {
                            setOpenTermoAceite(true);
                        } else {
                            simular(listaTermosAceiteState)
                        }

                    }}
                />
            </div>
        </div>
        {financeirasListState && <FinanciamentosGrid
            simulacao={simulacaoState}
            simulacoes={simlulacaoResultState}
            financeiras={financeirasListState.data}
            financeirasHabilitadas={financeirasHabilitadas}
            onChange={(simulacao, financeira, parcela) => {
                setConfirmData({ simulacao: simulacao, financeira: financeira, parcela: parcela })

                setDisabled(simulacao === null && financeira === null && parcela === null)
                if (!solo) {
                    onChange(simulacao, financeira, parcela)
                }
            }}
        />}

        {solo && (<>
            <div className="row actions">
                <div className="X12 S6 M4 L2 S--offset6 M--offset8 L--offset10">
                    <FullWidthButton
                        text="Confirmar"
                        variant="contained"
                        color="primary"
                        disableElevation
                        disabled={disabled || disabledConfirmar || (confirmData.financeira === null && confirmData.parcela === null && confirmData.simulacao === null)}
                        onClick={() => {
                            if (!validacao()) {
                                return;
                            }
                            onChange(confirmData.simulacao, confirmData.financeira, confirmData.parcela)
                        }}
                    />
                </div>
            </div>
        </>)}

        <TermosDeAceite
            codigoPedido={String(pedido?.codigo_venda)}
            open={openTermosAceite}
            tipo={TTIPO_TERMO_ACEITE.FINANCEIRAS}
            termosFinancieras={validaExibicaoTermos()}
            onClose={() => {
                setOpenTermoAceite(false);
            }}
            onConfirm={(_termos) => {
                if (pedido?.codigo_venda) {
                    simular(_termos.termos);
                    setOpenTermoAceite(false);
                    setListaTermosAceiteState(_termos.termos);
                }
            }}
        />

        {openModalSCR && <ModalSCR open={openModalSCR} onClose={() => openModalSCR$.next(false)}/>}
    </div>
}

export { Financeiras }